<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Charge Mapping Info.</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')" (keydown.enter)="$event.preventDefault()"></button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="card-body" [formGroup]="chargeDetailsForm">
                    <!-- <div class="row mb-2">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select" [items]="countryList" bindLabel="name" [bindValue]="'isocode'" (change)="onOriginCountryChange()" />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" formControlName="ddlOriginState" placeholder="Select" [items]="originStateList" bindLabel="name" [bindValue]="'isocode'" (change)="onOriginStateChange()" />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="city" class="form-label">city</label>
                                <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select" [items]="originCityList" bindLabel="name" [bindValue]="'isocode'" />
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-4">
                        <div class="col-md-3" *ngIf="chargeTypeFuelSurecharge">
                            <div class="mb-2">
                                <label for="charge" class="form-label">Charges <span class="mandatory">*</span> </label>
                                <ng-select id="charge" formControlName="ddlCharge" placeholder="Select"
                                    [items]="chargesOptions" bindLabel="name" [bindValue]="'id'" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [ngClass]="{'is-invalid':(isFormSubmitted ||chargeDetailsForm.get('ddlCharge').touched) &&chargeDetailsForm.get('ddlCharge').errors}" />
                                <div *ngIf="(isFormSubmitted || chargeDetailsForm.get('ddlCharge').touched) &&chargeDetailsForm.get('ddlCharge').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargeDetailsForm.get('ddlCharge').errors.required">Charge is
                                        Required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="product" class="form-label">Product</label>
                                <ng-select id="product" formControlName="ddlProduct" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="productOptions" bindLabel="name" [bindValue]="'id'" >
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="formVendor" class="form-label">Vendor</label>
                                <ng-select id="formVendor" formControlName="ddlVendor" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="vendorOptions" bindLabel="name" [bindValue]="'id'"
                                    (change)="bindService('')" >
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="service" class="form-label">Service</label>
                                <ng-select id="service" formControlName="ddlService" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="serviceOptions" bindLabel="servicename" [bindValue]="'servicename'" >
                                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                        <span>{{ item.name }}</span>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Location</div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country</label>
                                <ng-select id="country" formControlName="ddlDestinationCountry" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationcountryList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onDestinationCountryChange()" />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationStateList" bindLabel="name" [bindValue]="'isocode'"
                                    (change)="onDestinationStateChange()" />
                            </div>
                        </div>
                        <div class="col-md-3 mt-1">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    [items]="destinationCityList" bindLabel="name" [bindValue]="'isocode'" />
                            </div>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label class="form-label" for="chargeType">Calculation By </label>
                                <div>
                                    <div role="group" aria-label="radio button group" class="btn-group">
                                        <input type="radio" id="btnradio4" autocomplete="off"
                                            formControlName="txtCalculationBy" value="Percentage" class="btn-check" >
                                        <label for="btnradio4"
                                            class="btn btn-outline-secondary btn-sm">Percentage</label>
                                        <input type="radio" id="btnradio5" autocomplete="off" class="btn-check"
                                            formControlName="txtCalculationBy" value="Amount" >
                                        <label for="btnradio5" class="btn btn-outline-secondary btn-sm">Amount</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label for="minAmount" class="form-label">Amount </label>
                            <div class="input-group mb-2">
                                <span class="input-group-text group-label-sm">Minimum</span>
                                <input type="number" class="form-control form-control-sm"
                                    formControlName="txtMinimumAmount" 
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargeDetailsForm.get('txtMinimumAmount')?.touched) && chargeDetailsForm.get('txtMinimumAmount').errors}">
                                <div *ngIf="(isFormSubmitted || chargeDetailsForm.get('txtMinimumAmount')?.touched) && chargeDetailsForm.get('txtMinimumAmount').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargeDetailsForm.get('txtMinimumAmount').errors?.pattern">Invalid value. Please enter a number of max length 10 with up to three decimal
                                        places.
                                    </span>
                                </div>
                                <span class="input-group-text group-label-sm">Chargeable</span>
                                <input type="number" class="form-control form-control-sm"
                                    formControlName="txtChargeableAmount"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargeDetailsForm.get('txtChargeableAmount')?.touched) && chargeDetailsForm.get('txtChargeableAmount').errors}">
                                <div *ngIf="(isFormSubmitted || chargeDetailsForm.get('txtChargeableAmount')?.touched) && chargeDetailsForm.get('txtChargeableAmount').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargeDetailsForm.get('txtChargeableAmount').errors.required">Chargeable Amount is required
                                    </span>
                                    <span *ngIf="chargeDetailsForm.get('txtChargeableAmount').errors?.pattern">Invalid value. Please enter a number of max length 10 with up to three decimal
                                        places.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-md-1">
                            <div class="mb-2">
                                <label class="form-label" for="minimumValue">Minimum Amount</label>
                                <input class="form-control form-control-sm" type="number"
                                    formControlName="txtMinimumAmount" id="minimumValue"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargeDetailsForm.get('txtMinimumAmount')?.touched) && chargeDetailsForm.get('txtMinimumAmount').errors}">
                                <div *ngIf="(isFormSubmitted || chargeDetailsForm.get('txtMinimumAmount')?.touched) && chargeDetailsForm.get('txtMinimumAmount').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="chargeDetailsForm.get('txtMinimumAmount').errors.pattern"> Invalid
                                        value.
                                        Please enter a number of max length 10 with up to two decimal
                                        places.</span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="mb-2">
                                <label class="form-label" for="chargeableamount">Chargeable Amount<span
                                        class="mandatory">*</span></label>
                                <input class="form-control form-control-sm" type="number"
                                    formControlName="txtChargeableAmount" id="chargeableamount"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || chargeDetailsForm.get('txtChargeableAmount')?.touched) && chargeDetailsForm.get('txtChargeableAmount').errors}">
                                <div *ngIf="(isFormSubmitted || chargeDetailsForm.get('txtChargeableAmount')?.touched) && chargeDetailsForm.get('txtChargeableAmount').errors"
                                    class="invalid-feedback">
                                    <span
                                        *ngIf="chargeDetailsForm.get('txtChargeableAmount').errors.required">Chargeable
                                        Amount is required</span>
                                    <span *ngIf="chargeDetailsForm.get('txtChargeableAmount').errors?.pattern">Invalid
                                        value.
                                        Please
                                        enter a number of max length 10 with up to two decimal places.</span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button title="Update" type="button" class="btn btn-primary " (click)="upsertMapping()" (keydown.enter)="upsertMapping()" data-dismiss="modal">Update</button>
    <button type="button" class="btn btn-secondary " data-dismiss="modal"
        (click)="activeModal.dismiss('Cross click')">Cancel</button>
</div>